/* ============
 * Add multiple products modal
 * ============
 *
 * This is the component for creating batch log
 */
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      search: '',
      selected: [],
      loading: false,
      submitLoading: false,
    };
  },
  props: {
    selectedProducts: {
      type: Array,
      required: true,
      default: [],
    },
    warehouseId: {
      type: Number,
      required: false,
      default: 0,
    },
    onSave: {
      type: Function,
      required: true,
      default: () => {},
    },
    onClose: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({}),
  },

  mounted() {
    this.selected = [...this.selectedProducts].map((p) =>
      Object.assign({}, p, { selectedQty: p.qtyNumber })
    );
  },
  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    handleSubmit() {
      this.submitLoading = true;
      this.onSave(this.selected)
        .then(() => {
          this.submitLoading = false;
          this.closeModal();
        })
        .catch((errors) => {
          if (errors.items) {
            this.$message({
              showClose: true,
              message: this.$t(
                'static.bulkDestroyProducts.emptySelectionError'
              ),
              type: 'error',
            });
          }
          this.submitLoading = false;
        });
    },

    /**
     * Disable submit button in case of loading and non selected products.
     */
    disableSubmit() {
      return Boolean(!this.loading && !this.selected.length > 0);
    },

    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
      this.onClose();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/bulkDestroyProductModal/bulkDestroyProductModal.js